import * as React from "react";
import { Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { VolumeItem } from "./volumeItem";
import { formSet, formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { store } from "../../../../store";
import { cloneDeep } from "lodash";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { VolumeFirewallRecommendations } from "./VolumeFirewallRecommendations";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { getDefaultVolumeInput } from "../utils/volume";

interface Props {
  index: number;
}
export const WorkloadContainerVolumes: React.FC<Props> = React.memo(({ index }) => {
  const { id } = useCpFormContext();
  const volumes = useCpFormValue(`containers.${index}.volumes`);

  function add() {
    const _items = cloneDeep(volumes);
    _items.push(getDefaultVolumeInput());
    formSetValue(id, `containers.${index}.volumes`, _items);

    const form = store.getState().form.instances[id];
    const onBlurCounter = form.meta.onBlurCounter;
    formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
  }

  return (
    <>
      <VolumeFirewallRecommendations index={index} />
      <div style={{ display: "grid", gridTemplateColumns: `180px 4fr 3fr`, gap: `0.5rem` }}>
        {volumes.length < 1 ? null : (
          <>
            <div className="col-span-2">URI</div>
            <div className="col-span-1">Path</div>
          </>
        )}
        {volumes.map((volume, volumeIndex) => {
          return <VolumeItem key={volume.id} containerIndex={index} index={volumeIndex} />;
        })}
      </div>
      <CpErrorWarning name={`containers.${index}.volumesroot`} />
      <Button type="dashed" icon={<PlusCircleOutlined />} onClick={() => add()} className="mt-1">
        Add Volume
      </Button>
    </>
  );
});
